import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../maruciapiercer/sobremim_maruciapiercer.module.scss";
import { ArrowLeft } from "lucide-react";
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import InstagramIcon from "../../icons/instagramIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";

const Sobremim_maruciapiercer: React.FC = () => {
    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
    return (
        <div className={styles.sobremim_maruciapiercer}>
            {/* Header */}
            <div className={styles.header}>
                <button
                    className={styles.backButton}
                    onClick={() => navigate("/maruciapiercer")}
                    aria-label="Voltar"
                >
                    <ArrowLeft size={24} />
                </button>
                <h1 className="mb-0">Sobre Mim</h1>
            </div>

            {/* Conteúdo principal */}
            <div className={styles.mainContent}>
                <div className={styles.imagePlaceholder}>
                    <img src={require("./src/sobremim.png")} alt="Marúcia Piercer" />
                </div>

                <div className={styles.textContent}>
                    <h2>Marúcia Sunamita</h2>
                    <p>
                        Sou Marúcia, profissional apaixonada pelo que faz e dedicada a oferecer
                        um atendimento seguro, acolhedor e cheio de significado.
                    </p>
                    <p>
                        Atuo há mais de 7 anos com piercing, comprometida com a biossegurança,
                        estudo contínuo e aperfeiçoamento do meu trabalho. Acredito que cada
                        pessoa que confia em mim merece uma experiência positiva da conversa
                        inicial ao resultado final.
                    </p>
                    <p>
                        O designer de sobrancelhas e depilação surgiu como uma extensão do meu
                        trabalho, que através deles encontrei uma forma de valorizar a beleza e
                        autoestima de cada cliente.
                    </p>
                    <p>
                        Ao longo da minha caminhada, aprendi que cada atendimento é único e que
                        por trás de cada furo, depilação ou sobrancelha há uma história, uma
                        motivação. Por isso, levo o respeito como princípio que guia cada etapa
                        do meu trabalho.
                    </p>
                    <p>
                        Sendo mulher, mãe e alguém que entende que cada pessoa que me procura
                        quer valorizar o seu EU. Tudo o que faço é com dedicação, amor e o desejo
                        de que cada pessoa saia daqui se sentindo mais confiante, bonita e leve.
                    </p>
                </div>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <div className={styles.footerIcons}>
                    <a
                        href="https://wa.me/5516991127373?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <WhatsappIcon height="34" color="#fff" />
                    </a>
                    <a
                        href="https://www.instagram.com/marucia.piercer?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon height="28" color="#fff" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/Q7x2Qq3FkowMMJzd7"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon height="34" color="#fff" />
                    </a>
                </div>

                <p className={styles.footerText}>
                    Marúcia Sunamita <span className={styles.dot}>•</span> Piercing Barretos
                </p>

                <p className={styles.devBy}>
                    Desenvolvido por{" "}
                    <a
                        href="https://www.linksvibe.com.br"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Links Vibe
                    </a>
                </p>
            </div>

            {/* Botão flutuante do WhatsApp */}
            <a
                href="https://wa.me/5516991127373?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                target="_blank"
                rel="noopener noreferrer"
                className={styles.whatsappButton}
                aria-label="Contato WhatsApp"
            >
                <WhatsappIcon color="#fff" height="28" />
            </a>
        </div>
    );
};

export default Sobremim_maruciapiercer;
